<template>
	<Card class="card-step">
		<Form ref="registrationForm" :rules="rules" :model="formItem" label-position="top">
			<div class="title">
				<Icon type="ios-arrow-forward"></Icon>
				<span>{{ $t('基本資料') }}</span>
				<Divider />
			</div>
			<Row>
				<Col :xs="24" :sm="24" :md="19" :lg="19">
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('中文姓名')" prop="Name">
									<Input v-model="formItem.Name" :disabled="isdisableEdit"></Input>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('英文姓名')">
									<Row>
										<Col :xs="24" :sm="24" :md="12" :lg="12" class="mt-0 mb-0">
											<FormItem prop="LastNameInEnglish" class="mt-0">
												<Input
													v-model="formItem.LastNameInEnglish"
													:disabled="isdisableEdit"
												></Input>
												<span class="description">{{ $t('姓(例如 : 李，請輸入LI)') }}</span>
											</FormItem>
										</Col>
										<Col :xs="24" :sm="24" :md="12" :lg="12" class="mt-0 mb-0">
											<FormItem prop="NameInEnglish" class="mt-0">
												<Input
													v-model="formItem.NameInEnglish"
													:disabled="isdisableEdit"
												></Input>
												<span class="description">{{
													$t('名(例如 : 鈴鈴，請輸入Ling-Ling)')
												}}</span>
											</FormItem>
										</Col>
									</Row>
								</FormItem>
							</Col>
						</Row>
						<Row>
							<Col
								class="mt-0"
								:xs="24"
								:sm="24"
								:md="{ span: 12, offset: 12 }"
								:lg="{ span: 12, offset: 12 }"
							>
								<div class="description">
									1. {{ $t('請填寫與護照相同之英文姓名，如無護照者請參考護照外文拼音。') }}
									<br />
									2. {{ $t('學生請登載你的英文姓名，請務必填寫正確。') }}
									<br />
									3. {{ $t('入學後如因學生證上英文姓名錯誤欲換發新證者，需自行負擔換發工本費150元') }}
								</div>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('系所全名')">
									<Input :value="$options.filters.I18nColumn(gradeDdata, 'Department')" disabled>{{
										planId
									}}</Input>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('班別')">
									<Input :value="$options.filters.I18nColumn(gradeDdata, 'Class')" disabled></Input>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('出生年月日')" prop="DateOfBirth">
									<DatePicker
										type="date"
										style="width: 100%"
										:placeholder="$t('請選擇日期')"
										v-model="formItem.DateOfBirth"
										:disabled="isdisableEdit"
									></DatePicker>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('身份證號碼/護照號碼(有效護照)')" prop="IdCode">
									<Input v-model="formItem.IdCode" :disabled="isdisableEdit"></Input>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('身分類別')" prop="TypeOfIdentity">
									<Select v-model="formItem.TypeOfIdentity" :disabled="isdisableEdit">
										<Option
											v-for="item in parameters.p_sdlnclass"
											:value="item.PhsiName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
										>
									</Select>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('僑居地/國別/族別')" prop="Nationality">
									<Input v-model="formItem.Nationality" :disabled="isdisableEdit"></Input>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Col :xs="24" :sm="24" :md="12" :lg="12">
							<FormItem :label="$t('性別')" prop="Sex">
								<RadioGroup v-model="formItem.Sex">
									<Radio label="M" :disabled="isdisableEdit">{{ $t('男') }}</Radio>
									<Radio label="F" :disabled="isdisableEdit">{{ $t('女') }}</Radio>
								</RadioGroup>
							</FormItem>
						</Col>
						<Col :xs="24" :sm="24" :md="12" :lg="12">
							<FormItem :label="$t('過去是否曾以僑生身份來臺就讀')" prop="IsComeBefore">
								<RadioGroup v-model="formItem.IsComeBefore">
									<Radio label="true" :disabled="isdisableEdit">{{ $t('是') }}</Radio>
									<Radio label="false" :disabled="isdisableEdit">{{ $t('否') }}</Radio>
								</RadioGroup>
							</FormItem>
						</Col>
					</FormItem>
				</Col>
				<Col :xs="24" :sm="24" :md="5" :lg="5">
					<img :src="photoSrc" style="width: 100%; margin-top: 30px; max-height: 400px" />
					<Upload
						ref="upload"
						type="drag"
						:action="actionSrc"
						style="margin: 20px 0px 20px 0px"
						:format="['jpg', 'jpeg']"
						:max-size="1024"
						:on-format-error="handleFormatError"
						:on-exceeded-size="handleMaxSize"
						:on-success="successUpload"
						v-show="!isdisableEdit"
					>
						<div style="padding: 5px 0">
							<Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
							<p>{{ $t('上傳照片') }}</p>
						</div>
					</Upload>
				</Col>
			</Row>
			<div class="title">
				<Icon type="ios-arrow-forward"></Icon>
				<span>{{ $t('入學資料') }}</span>
				<Divider />
			</div>
			<Row>
				<Col :xs="24" :sm="24" :md="19" :lg="19">
					<FormItem>
						<FormItem :label="$t('入學類別')">
							<Input
								:value="
									$options.filters.I18nColumn(gradeDdata, 'Department') +
										$options.filters.I18nColumn(gradeDdata, 'Class') +
										$t('招生')
								"
								disabled
							></Input>
						</FormItem>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('入學身份')" prop="AdmissionOfIdentity">
									<Select v-model="formItem.AdmissionOfIdentity" :disabled="isdisableEdit">
										<Option
											v-for="item in parameters.p_Admission"
											:value="item.PhsiName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
										>
									</Select>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('入學資格')" prop="AdmissionOfQualification">
									<Select
										v-model="formItem.AdmissionOfQualification"
										@on-change="admissionOfQualificationChange"
										:disabled="isdisableEdit"
									>
										<Option
											v-for="item in parameters.p_Qualification"
											:value="item.PhsiName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
										>
									</Select>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('個人身份')" prop="PersonalOfIdentity">
									<Select v-model="formItem.PersonalOfIdentity" disabled>
										<Option
											v-for="item in parameters.p_Personal"
											:value="item.PhsiName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
										>
									</Select>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('特殊身份')" prop="SpecialOfIdentity">
									<Select v-model="formItem.SpecialOfIdentity" disabled>
										<Option
											v-for="item in parameters.p_Special"
											:value="item.PhsiName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
										>
									</Select>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="12" :sm="12" :md="6" :lg="6">
								<FormItem :label="$t('學歷類型')" prop="GraduatedSchoolType">
									<Select
										v-model="formItem.GraduatedSchoolType"
										@on-change="schoolTypeChange"
										:disabled="isdisableEdit"
									>
										<Option
											v-for="item in parameters.p_SchoolAreaType"
											:value="item.PhsiName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}
										</Option>
									</Select>
								</FormItem>
							</Col>
							<Col :xs="12" :sm="12" :md="6" :lg="6">
								<FormItem
									:label="$t('入學前畢業學校')"
									v-if="isShowSchoolSelect"
									prop="GraduatedSchool"
								>
									<Select v-model="formItem.GraduatedSchool" filterable :disabled="isdisableEdit">
										<Option
											v-for="item in graduatedSchools"
											:value="item.DispName"
											:key="item.PhsiName"
											>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
										>
									</Select>
								</FormItem>
								<FormItem :label="$t('入學前畢業學校')" v-else prop="GraduatedSchool">
									<i-input v-model="formItem.GraduatedSchool" :disabled="isdisableEdit"></i-input>
								</FormItem>
							</Col>
							<i-col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('入學前畢業日期')" prop="DateOfGraduated">
									<DatePicker
										type="date"
										:placeholder="$t('請選擇日期')"
										v-model="formItem.DateOfGraduated"
										style="width: 100%"
										:disabled="isdisableEdit"
									></DatePicker>
								</FormItem>
							</i-col>
						</Row>
					</FormItem>
				</Col>
			</Row>
			<div class="title">
				<Icon type="ios-arrow-forward"></Icon>
				<span>{{ $t('通訊資料') }}</span>
				<Divider />
			</div>
			<Row>
				<Col :xs="24" :sm="24" :md="19" :lg="19">
					<FormItem :label="$t('戶籍地址')" class="pr-10" prop="HomeAddress">
						<ApplicationZipAddress
							v-if="isTaiwanese"
							v-model="formItem.HomeAddress"
							:disabled="isdisableEdit"
							ref="homeZipAddress"
						/>
						<Input v-else v-model="formItem.HomeAddress" :disabled="isdisableEdit"></Input>
						<div v-if="isTaiwanese">
							{{ $t('*請參閱身分證背面資訊填寫') }}
							<u>{{ $t('鄰、里') }}</u>
						</div>
					</FormItem>
					<FormItem class="pr-10" prop="Address" style="margin-bottom: 25px; margin-top: 25px">
						<label class="ivu-form-item-label mr-10">
							{{ $t('通訊地址') }}
							<a class="ml-10" style="text-decoration: underline" @click="sameAsHomeAddress()" :disabled="isdisableEdit">{{
								$t('同戶籍地址')
							}}</a>
						</label>
						<!-- <ApplicationZipAddress
							v-if="isTaiwanese"
							v-model="formItem.Address"
							:disabled="isdisableEdit"
							ref="zipAddress"
						/> -->
						<Input v-model="formItem.Address" :disabled="isdisableEdit"></Input>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('日間室內聯絡電話')" prop="Telephone">
									<Input v-model="formItem.Telephone" :disabled="isdisableEdit"></Input>
									<div>{{ $t('填寫範例 : 02xxxxxxxx(#xxxx如有分機)') }}</div>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('夜間室內聯絡電話')" prop="NightTelephone">
									<Input v-model="formItem.NightTelephone" :disabled="isdisableEdit"></Input>
									<div>{{ $t('填寫範例 : 02xxxxxxxx(#xxxx如有分機)') }}</div>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('手機')" prop="Mobile">
									<Input v-model="formItem.Mobile" :disabled="isdisableEdit"></Input>
									<div>{{ $t('填寫範例 : 09xxxxxxxx 共10碼') }}</div>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('E-mail')" class="pr-10" prop="Email">
									<Input v-model="formItem.Email" :disabled="isdisableEdit"></Input>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
				</Col>
			</Row>
			<div class="title">
				<Icon type="ios-arrow-forward"></Icon>
				<span>{{ $t('緊急聯絡資料') }}</span>
				<Divider />
			</div>
			<Row>
				<Col :xs="24" :sm="24" :md="19" :lg="19">
					<FormItem>
						<Col :xs="24" :sm="24" :md="12" :lg="12">
							<FormItem :label="$t('緊急聯絡人')" prop="ContactName">
								<Input v-model="formItem.ContactName" :disabled="isdisableEdit"></Input>
							</FormItem>
						</Col>
						<Col :xs="24" :sm="24" :md="12" :lg="12">
							<FormItem :label="$t('緊急聯絡人關係')" prop="ContactRelationship">
								<Select v-model="formItem.ContactRelationship" :disabled="isdisableEdit">
									<Option
										v-for="item in parameters.p_Relationship"
										:value="item.PhsiName"
										:key="item.PhsiName"
										>{{ $options.filters.I18nColumn(item, 'DispName') }}</Option
									>
								</Select>
							</FormItem>
						</Col>
					</FormItem>
					<FormItem>
						<Row>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('緊急聯絡人電話')" prop="ContactPhone">
									<Input v-model="formItem.ContactPhone" :disabled="isdisableEdit"></Input>
								</FormItem>
							</Col>
							<Col :xs="24" :sm="24" :md="12" :lg="12">
								<FormItem :label="$t('緊急聯絡人手機')" prop="ContactMobile">
									<Input v-model="formItem.ContactMobile" :disabled="isdisableEdit"></Input>
								</FormItem>
							</Col>
						</Row>
					</FormItem>
				</Col>
			</Row>
			<div class="title">
				<Icon type="ios-arrow-forward"></Icon>
				<span>{{ $t('備註') }}</span>
				<Divider />
			</div>
			<Row>
				<Col :xs="24" :sm="24" :md="19" :lg="19">
					<FormItem class="pr-10">
						<Input
							v-model="formItem.Description"
							type="textarea"
							:autosize="{ minRows: 2, maxRows: 5 }"
							:placeholder="$t('請輸入...')"
							:disabled="isdisableEdit"
						></Input>
					</FormItem>
				</Col>
			</Row>
			<FormItem>
				<Row type="flex" justify="center" align="middle">
					<Col :xs="24" :sm="5" :md="4" :lg="4" v-if="!isdisableEdit">
						<Button class="text-center btn" type="info" @click="isShowModal = true">{{
							$t('確認填寫完成')
						}}</Button>
					</Col>
					<Col :xs="24" :sm="5" :md="4" :lg="4" v-if="!isdisableEdit">
						<Button class="text-center btn" type="primary" @click="submit(false)">{{ $t('儲存') }}</Button>
					</Col>
					<Col :xs="24" :sm="5" :md="4" :lg="4">
						<Button class="text-center btn" @click="goBack">{{ $t('返回') }}</Button>
					</Col>
				</Row>
			</FormItem>
		</Form>
		<Spin size="large" fix v-if="spinShow"></Spin>
		<Modal
			width="700"
			v-model="isShowModal"
			@on-ok="checkOk"
			:mask-closable="false"
			:ok-text="$t('確定')"
			:cancel-text="$t('取消')"
		>
			<span slot="header" style="font-size: 30px">
				<Icon type="md-warning" style="color: #ff9900" />
				<span>{{ $t('警告') }}</span>
			</span>
			<span style="font-size: 20px">
				{{ $t('請注意：提交後資料即鎖定無法進行修改！') }}
				<br />
				{{
					$t(
						'點選「確定」後系統將進行欄位檢查，若資料未鎖定表示尚有項目未填寫／填寫格式錯誤，敬請參照紅框說明進行修正。',
					)
				}}
			</span>
		</Modal>
	</Card>
</template>
<script>
import { FRESHMAN_APPLICATION, FRESHMAN_APPLICATION_STATUS } from '@/models/FreshmanApplication.ts'
import ParaService from '@/services/ParaService'
import ApplicationZipAddress from './ApplicationZipAddress'

export default {
	components: {
		ApplicationZipAddress,
	},
	data: function() {
		return {
			planId: this.$route.params.planId,
			formItem: Object.assign({}, FRESHMAN_APPLICATION),
			rules: this.getRules(), //表單驗證規則
			parameters: {},
			gradeDdata: {
				Class: null, //班別
				ClassInEnglish: null,
				Department: null, //系所
				DepartmentInEnglish: null,
			},
			isdisableEdit: true, //是否禁止編輯
			spinShow: true, //載入顯示
			isUpload: false, //是否有上傳大頭照
			photoData: null, //照片資料
			isShowModal: false, //顯示警告視窗
			graduatedSchools: null, //学校列表
			isShowSchoolSelect: false, //显示学校下拉框
			//身份類別對應入學身份
			//一般生 B：臺灣地區人民
			//港澳生 G：香港澳門居民
			//外籍生 H：外國籍人土
			//大陸地區學生 K：大陸地區學生
			AdmissionOfIdentityMap: {
				1: 'B',
				2: 'G',
				3: 'H',
				4: 'K',
			},
		}
	},
	computed: {
		photoSrc() {
			if (this.formItem.FileId) {
				return `api/File/${this.formItem.FileId}`
			} else {
				return ''
			}
		},
		actionSrc() {
			if (this.formItem.Id) {
				return `api/FreshmanApplication/?applicationId=${this.formItem.Id}`
			} else {
				return ''
			}
		},
		isTaiwanese() {
			return this.formItem.TypeOfIdentity == '1' //是否為台灣人
		},
	},
	async created() {
		this.parameters = await ParaService.get([
			'p_sdlnclass',
			'p_Admission',
			'p_Personal',
			'p_Special',
			'p_Qualification',
			'p_Relationship',
			'p_SchoolOfUndergraduate',
			'p_ChinaSchoolOfUndergraduate',
			'p_SchoolOfAcademy',
			'p_SchoolAreaType',
		])
	},
	async mounted() {
		//抓取報名資料
		await this.getApplication()
		//抓取系所以及班別
		this.getClassAndDepartment()
		this.spinShow = false
	},
	methods: {
		getRules() {
			return {
				Name: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validateName,
					},
				],
				NameInEnglish: [
					{
						required: true,
						validator: this.validateNameInEnglish,
						trigger: 'blur',
						transform(value) {
							return value.trim()
						},
					},
				],
				LastNameInEnglish: [
					{
						required: true,
						validator: this.validateNameInEnglish,
						trigger: 'blur',
						transform(value) {
							return value.trim()
						},
					},
				],
				DateOfBirth: [
					{
						required: true,
						type: 'date',
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				IdCode: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validateIdCode,
					},
				],
				TypeOfIdentity: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				Nationality: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				Sex: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				AdmissionOfIdentity: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				AdmissionOfQualification: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				IsComeBefore: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				PersonalOfIdentity: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'blur',
					},
				],
				SpecialOfIdentity: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'blur',
					},
				],
				GraduatedSchool: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				GraduatedSchoolType: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				DateOfGraduated: [
					{
						required: true,
						type: 'date',
						message: this.$t('欄位不可為空'),
						trigger: 'change',
					},
				],
				Address: [
					{
						required: true,
						validator: this.validateAddress,
						trigger: 'change',
					},
				],
				HomeAddress: [
					{
						required: true,
						validator: this.validateHomeAddress,
						trigger: 'blur',
					},
				],
				Mobile: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validatePhone,
					},
				],
				Email: [
					{
						required: true,
						message: this.$t('請填寫正確E-mail'),
						trigger: 'blur',
						type: 'email',
					},
				],
				ContactName: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'blur',
					},
				],
				ContactRelationship: [
					{
						required: true,
						message: this.$t('欄位不可為空'),
						trigger: 'blur',
					},
				],
				ContactPhone: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validatePhone,
					},
				],
				ContactMobile: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validatePhone,
					},
				],
				Telephone: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validatePhone,
					},
				],
				NightTelephone: [
					{
						required: true,
						trigger: 'blur',
						validator: this.validatePhone,
					},
				],
			}
		},
		validateNameInEnglish(rule, value, callback) {
			if (!value) {
				callback(new Error(this.$t('欄位不可為空')))
			}

			if (!/^[a-zA-Z~!@#$%^&amp;*()_+=\-`[\]{}';:.,;/?|\s]*$/.test(value)) {
				callback(new Error(this.$t('僅支援半形英文與符號（不可輸入其他語言）')))
			}
			callback()
		},
		validatePhone(rule, value, callback) {
			if (!value) {
				callback(new Error(this.$t('欄位不可為空')))
			}

			if (!/^[0-9~!@#$%^&amp;*()_+=\-`[\]{}';:.,;/?|\s]*$/.test(value)) {
				callback(new Error(this.$t('僅支援半形數字及符號')))
			}
			callback()
		},
		validateIdCode(rule, value, callback) {
			if (!value) {
				callback(new Error(this.$t('欄位不可為空')))
			}

			if (this.isTaiwanese && !/^[a-zA-Z0-9]*$/.test(value)) {
				callback(new Error(this.$t('僅支援半形英數')))
			}

			if (this.isTaiwanese && !this.checkTaiwanIdCode(value)) {
				callback(new Error(this.$t('請輸入正確的身分證號')))
			}
			callback()
		},
		validateName(rule, value, callback) {
			if (!value) {
				callback(new Error(this.$t('欄位不可為空')))
			}

			if (!/^[\u4e00-\u9fa5]*$/.test(value)) {
				callback(new Error(this.$t('僅支援中文字（不可輸入符號空格等）')))
			}
			callback()
		},
		validateAddress(rule, value, callback) {
			if (!value) {
				callback(new Error(this.$t('欄位不可為空')))
			}
			// //如果為台灣學生，則加上地址檢查
			// if (this.isTaiwanese) {
			// 	if (!this.$refs.zipAddress.validateAddressOnly()) {
			// 		callback(new Error(this.$t('欄位不可為空')))
			// 	}
			// }
			callback()
		},
		validateHomeAddress(rule, value, callback) {
			if (!value) {
				return callback(new Error(this.$t('欄位不可為空')))
			}
			//如果為台灣學生，則加上村里鄰郵遞區號檢查
			if (this.isTaiwanese) {
				if (!this.$refs.homeZipAddress.validate()) {
					callback(new Error(this.$t('欄位不可為空')))
				}
			}
			return callback()
		},
		async getApplication() {
			try {
				let response = await this.$http.get(`api/FreshmanApplication/Application/${this.planId}`)
				this.formItem = Object.assign(this.formItem, response.data)
				this.formItem.IsComeBefore = this.formItem.IsComeBefore.toString()
				//個人身份預設第一筆
				this.formItem.PersonalOfIdentity = this.formItem.PersonalOfIdentity
					? this.formItem.PersonalOfIdentity
					: '10'
				//特殊身份預設第一筆
				this.formItem.SpecialOfIdentity = this.formItem.SpecialOfIdentity
					? this.formItem.PersonalOfIdentity
					: '10'
				//預設入學身份
				this.formItem.AdmissionOfIdentity = this.GetTypeOfIdentity(this.formItem)
				//判斷是否可以編輯
				this.isdisableEdit = response.data.Status === FRESHMAN_APPLICATION_STATUS.WriteDone ? true : false
				this.isUpload = response.data.FileId ? true : false
				this.formItem.GraduatedSchoolType && this.initGraduatedSchool(this.formItem.GraduatedSchoolType)
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
		GetTypeOfIdentity(form) {
			if (form.AdmissionOfIdentity != null) return form.AdmissionOfIdentity
			return this.AdmissionOfIdentityMap[form.TypeOfIdentity]
		},
		async getClassAndDepartment() {
			try {
				let response = await this.$http.get(`api/Department/Plans/${this.planId}`)
				//設定系所、班級中英文字
				this.gradeDdata.Class = response.data.Class
				this.gradeDdata.ClassInEnglish = response.data.ClassInEnglish
				this.gradeDdata.Department = response.data.Department
				this.gradeDdata.DepartmentInEnglish = response.data.DepartmentInEnglish
			} catch (err) {
				this.$Message.error(this.$t('查無資料'))
			}
		},
		async submit(ifCompleted) {
			//不為提交則先不驗證欄位
			if (ifCompleted) {
				this.$refs.registrationForm.validate(valid => {
					if (valid) {
						//確認提交才判斷是否有上傳大頭照
						if (this.isUpload) {
							this.save(ifCompleted)
						} else {
							this.$Message.error(this.$t('請上傳大頭照'))
						}
					} else {
						this.$Message.error(this.$t('資料填寫錯誤，請確認'))
					}
				})
			} else {
				this.save(ifCompleted)
			}
		},
		async save(ifCompleted) {
			try {
				this.spinShow = true
				let form = { ...this.formItem }
				form.DateOfBirth = form.DateOfBirth.asUTC()
				form.DateOfGraduated = form.DateOfGraduated.asUTC()

				await this.$http.post(`api/FreshmanApplication/Save/${ifCompleted}`, form)
				this.isdisableEdit = ifCompleted
				this.$Message.success(this.$t('儲存成功'))
			} catch (err) {
				this.$Message.error(this.$t('儲存失敗'))
			} finally {
				this.spinShow = false
			}
		},
		checkOk() {
			this.submit(true)
		},
		handleFormatError(file) {
			this.$Notice.warning({
				title: this.$t('格式錯誤'),
				desc: this.$t('請上傳格式:{0}', ['jpg,jpeg']),
			})
		},
		handleMaxSize(file) {
			this.$Notice.warning({
				title: this.$t('容量錯誤'),
				desc: this.$t('容量僅限1MB以內'),
			})
		},
		successUpload(fileId) {
			//清空上傳列表
			this.$refs.upload.clearFiles()
			this.formItem.FileId = fileId
			this.isUpload = true
		},
		goBack() {
			this.$router.go(-1)
		},
		sameAsHomeAddress() {
			this.formItem.Address = this.isTaiwanese
				? this.formItem.HomeAddress.replaceAll(',', '')
				: this.formItem.HomeAddress
		},
		admissionOfQualificationChange(PhsiName) {
			this.formItem.GraduatedSchoolType = null
			this.formItem.GraduatedSchool = null
			this.graduatedSchools = null
		},
		schoolTypeChange(value) {
			this.formItem.GraduatedSchool = null
			this.initGraduatedSchool(value)
		},
		initGraduatedSchool(value) {
			if (value === 'ABROAD') {
				this.isShowSchoolSelect = false
				this.graduatedSchools = null
				return
			}
			let qualification = this.formItem.AdmissionOfQualification
			//大學畢業、大學肄業
			if (qualification === '9' || qualification === 'J') {
				this.isShowSchoolSelect = true
				if (value === 'DOMESTIC') {
					this.graduatedSchools = this.parameters.p_SchoolOfUndergraduate
				} else if (value === 'CHINA') {
					this.graduatedSchools = this.parameters.p_ChinaSchoolOfUndergraduate
				}
				return
			}
			//專科畢業
			if (qualification === 'I') {
				this.isShowSchoolSelect = true
				if (value === 'DOMESTIC') {
					this.graduatedSchools = this.parameters.p_SchoolOfAcademy
				} else if (value === 'CHINA') {
					//大陸學校專科跟大學用同一組
					this.graduatedSchools = this.parameters.p_ChinaSchoolOfUndergraduate
				}
				return
			}
			this.isShowSchoolSelect = false
			this.graduatedSchools = null
		},
		checkTaiwanIdCode(id) {
			//A=10  台北市       J=18 新竹縣         S=26  高雄縣
			//B=11  台中市       K=19 苗栗縣         T=27  屏東縣
			//C=12  基隆市       L=20 台中縣         U=28  花蓮縣
			//D=13  台南市       M=21 南投縣         V=29  台東縣
			//E=14  高雄市       N=22 彰化縣         W=32  金門縣
			//F=15  台北縣       O=35 新竹市         X=30  澎湖縣
			//G=16  宜蘭縣       P=23 雲林縣         Y=31  陽明山
			//H=17  桃園縣       Q=24 嘉義縣         Z=33  連江縣
			//I=34  嘉義市       R=25 台南縣

			//判斷方式
			//X1 X2 為身分證第一碼英文字母對應的數字
			//Y = X1 + 9*X2 + 8*D1 + 7*D2 + 6*D3 + 5*D4 + 4*D5 + 3*D6 + 2*D7+ 1*D8 + D9
			//如 Y 能被 10 整除，則表示該身分證號碼為正確，否則為錯誤。

			const tab = 'ABCDEFGHJKLMNPQRSTUVXYWZIO'
			const A1 = new Array(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3)
			const A2 = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5)
			const Mx = new Array(9, 8, 7, 6, 5, 4, 3, 2, 1, 1)

			if (id.length !== 10) return false
			var i = tab.indexOf(id.charAt(0))
			if (i === -1) return false
			//取得X1 + 9*X2
			var sum = A1[i] + A2[i] * 9

			//取得sum + 8*D1 + 7*D2 + 6*D3 + 5*D4 + 4*D5 + 3*D6 + 2*D7+ 1*D8 + D9
			for (i = 1; i < 10; i++) {
				const v = parseInt(id.charAt(i))
				if (isNaN(v)) return false
				sum = sum + v * Mx[i]
			}

			//能被 10 整除，則表示該身分證號碼為正確，否則為錯誤。
			if (sum % 10 !== 0) return false
			return true
		},
	},
	watch: {
		'$i18n.locale': function() {
			location.reload()
		},
		parameters: function() {
			if (this.graduatedSchools) {
				return
			}
			this.initGraduatedSchool(this.formItem.GraduatedSchoolType)
		},
	},
}
</script>
<style lang="scss" scoped>
.title {
	margin-top: 14px;
}
.step-detail {
	font-family: MicrosoftJhengHeiRegular;
	margin: 10px 0px 0px 10px;
}
.ivu-divider {
	margin: 14px 0px 0px 0px;
}
.ivu-icon-ios-arrow-forward {
	color: dodgerblue;
}
.ivu-form-item {
	margin-bottom: 10px;
	margin-top: 10px;
}
.ivu-col {
	padding-right: 10px;
	margin-bottom: 10px;
	margin-top: 10px;
}
.pr-10 {
	padding-right: 10px;
}
.btn {
	width: 100%;
}
.mb-0 {
	margin-bottom: 0;
}
.mt-0 {
	margin-top: 0;
}
.description {
	line-height: 1.5;
	display: inline-block;
}
.mb-10 {
	margin-bottom: 10px;
}
.ml-10 {
	margin-left: 10px;
}
</style>
